export const trovaParametriPlugin = () => {
  const [, search] = window.location.href.split('?');
  const queryString = new URLSearchParams(search);
  const now = new Date().toISOString();
  const anno = new Date().getFullYear();

  const from = queryString.get('from');
  const idAnagrafica = queryString.get('idanagrafica') ?? '';
  const annoCampagna = now.substring(4) < window.config.dataCambioAnnoAUU.substring(4) ? anno - 1 : anno;

  return {
    idAnagrafica,
    annoCampagna: from === 'isee' ? annoCampagna : false,
  };
};
